import React from 'react'
import {observer, inject} from 'mobx-react'

import ProfileButton from './ProfileButton'
import WalletButton from './WalletButton'
import CashbackStatusButton from './CashbackStatusButton'
import Logout from './Logout'
import Dropdown from '../Dropdown'

const LoggedInHeader = ({ dropdownStore }) => {
  return (
    <div className='nav-perfil'>
      <Dropdown active={dropdownStore.showProfileDropdown}>
        <div className='nav-perfil__box__list'>
          <ProfileButton />
          <WalletButton />
          <CashbackStatusButton />
        </div>
        <div name='dropdown-grey' className='absolute pin w-full h-full bg-black hidd' style={{opacity: '0.5'}} />
      </Dropdown>
      <div className='nav-perfil__mobil-logged' onClick={dropdownStore.toggleProfileDropdown}>
        <i className='fas fa-user'/>
      </div>
      <Logout />
    </div>
  )
}

export default inject('dropdownStore')(observer(LoggedInHeader))



// WEBPACK FOOTER //
// ./src/components/Header/LoggedInHeader/index.js